enum AccessReportsAdminDashboardModalTypeEnum {
  ActivateVersion = "Activate Version",
  DeleteVersion = "Delete Version",
}

export { AccessReportsAdminDashboardModalTypeEnum };
